module.exports = __webpack_public_path__ + "static/media/platforms-comparison-info.626f0012.png";